import { Grid } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { AppBox, AppButton, AppTypography } from 'components'
import { ApiQueryKeys, appRoutes } from 'globals/constants'
import { jwtDecode } from 'jwt-decode'
import { useSnackbar } from 'notistack'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthApi, DecodedTokenViewModel, SessionModel, UserMembershipViewModel } from 'sdk'
import { useAppDispatch } from 'store/app.store'
import { setMemberships, setOwnerId, setRoles, setSession, setTrialExpiry, setUserId } from 'store/slices'

interface Props {}

export const OldCancelledMessage: FC<Props> = () => {
  const authApi = new AuthApi()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()

  const { mutate: restartTrial, isPending } = useMutation({
    mutationKey: [ApiQueryKeys.account.restartTrial],
    mutationFn: () => authApi.restartTrial(),
    onSuccess: (data: SessionModel) => {
      dispatch(setSession(data))
      dispatch(setUserId(data.UserId))
      const decoded: DecodedTokenViewModel = jwtDecode(data.JwtToken!)
      const parsedMemberships: UserMembershipViewModel[] = JSON.parse(decoded.Memberships)
      dispatch(setMemberships(parsedMemberships))
      dispatch(setTrialExpiry(decoded.TrialExpiry))
      dispatch(setOwnerId(decoded.AccountOwnerId))
      dispatch(setRoles(JSON.parse(decoded.role)))
      navigate(appRoutes.account.path)
    },
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
  })
  return (
    <AppBox height={'91vh'} alignContent={'center'}>
      <Grid container justifyContent={'center'} spacing={2}>
        <Grid item xs={4}>
          <AppBox backgroundColor="white" borderRadius={6} border={1} borderColor={'grey.200'} padding={2}>
            <AppBox borderBottom={1} borderColor={'grey.200'} paddingBottom={1}>
              <AppTypography fontSize={32} fontWeight={'bold'}>
                Your plan was cancelled
              </AppTypography>
            </AppBox>
            <AppTypography fontSize={16} fontWeight={400} color={'grey.500'} paddingTop={2}>
              We see you previously canceled your plan on our old platform. We would love to give you the opportunity to
              experience the power of our new system with a free 7-day trial. Simply click the <b>Restart Trial</b>{' '}
              button and complete the profile wizard. There’s no credit card required.{' '}
            </AppTypography>
            <AppBox textAlign={'right'} paddingTop={2}>
              <AppButton variant="contained" size="small" isLoading={isPending} onClick={() => restartTrial()}>
                Restart Trial
              </AppButton>
            </AppBox>
          </AppBox>
        </Grid>
        <Grid item xs={2}>
          <img
            src="/images/dashboard/old-subscription-cancelled/old-subscription-cancelled.png"
            alt="old-cancelled-message"
          />
        </Grid>
      </Grid>
    </AppBox>
  )
}
